import { render, staticRenderFns } from "./form20.vue?vue&type=template&id=a1c68aa0&scoped=true&"
import script from "./form20.vue?vue&type=script&lang=js&"
export * from "./form20.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c68aa0",
  null
  
)

export default component.exports